import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate';

import { UserRole } from "@/constants/UserRole";

Vue.use(Vuex);

const modules = {};

//Dynamically import and register the store modules
const requireModule = require.context("./modules", false, /\.js$/);
requireModule.keys().forEach((fileName) =>
{
  const moduleName = fileName.replace(/(\.\/|\.js)/g, "");
  const moduleConfig = requireModule(fileName);
  modules[moduleName] = moduleConfig.default || moduleConfig;
});


export default new Vuex.Store({
  modules,
  state: {
    barColor: "rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)",
    barImage: "https://climate-rx.herokuapp.com/main.jpg",
    drawer: null,
    miniDrawer: null,
    showChat: true,
    calendarDrawer: null,
    type: "month",
    snackbar: { show: false, text: "", color: "deep-purple accent-4" },
    isSaving: false,
    confirmedDialogCommon: false,
    userRoles: Object.values(UserRole).sort((a, b) => a.localeCompare(b)),
    staging: true // this is temporary for testing in staging
  },
  mutations: {
    SET_BAR_IMAGE(state, payload)
    {
      state.barImage = payload;
    },
    SET_DRAWER(state, payload)
    {
      state.drawer = payload;
      // console.log({drawer: payload})
    },
    SET_MINI_DRAWER(state, payload)
    {
      state.miniDrawer = payload;
      // console.log({miniDrawer: payload})
    },
    SET_SCRIM(state, payload)
    {
      state.barColor = payload;
    },
    SET_CHAT(state, payload)
    {
      state.showChat = payload;
    },
    SET_CALENDAR_DRAWER(state, payload)
    {
      state.calendarDrawer = payload;
    },
    SET_TYPE(state, payload)
    {
      state.type = payload;
    },
    SET_ISSAVING(state, payload)
    {
      state.isSaving = payload;
    },
    SET_SNACKBAR(state, { show, text, color })
    {
      let timeout = 0;

      if (state.snackbar.show)
      {
        state.snackbar.show = false;
        timeout = 100;
      }
      setTimeout(() =>
      {
        state.snackbar = {
          show: show,
          text: text,
          color: color,
        };
      }, timeout);
    },
    SET_CONFIRMED_DIALOG_COMMON(state, data)
    {
      state.confirmedDialogCommon = data;
    },
  },
  actions: {},

  plugins: [
    createPersistedState({
      paths: ['shifts.selectedShift'] // Specify the parts of the state to persist
    })
  ],
});
